<template>
  <div class="placeholder">
    <h1>cube<sup>11</sup></h1>
    <div class="cube cube--glowing">
      <img class="cube__glow" alt="" src="../assets/comming-soon.svg">
      <svg class="cube__neon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="200px" height="200px" viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
        <polygon fill="none" stroke="#FFFFFF" stroke-width="11" stroke-miterlimit="10" points="36.5,63.007 101,25.954 165.5,63.007 165.5,137.113 101,174.166 36.5,137.113"/>
      </svg>
    </div>
    <h3>But you can still contact us by:</h3>
    <ul>
      <li><a href="mailto:contact@cube11.pl" target="_blank">contact@cube11.pl</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CommingSoon'
}
</script>

<style scoped lang="scss">
h1,
h3 {
  font-weight: 300;
}
h1 {
  margin: 0;
}
.cube {
  position: relative;
  width: 300px;
  height: 300px;
  user-select: none;

  .cube__glow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    filter: blur(7px);
    animation: glow 2s ease-in-out infinite alternate;
  }
  .cube__neon {
    width: 100%;
    height: 100%;
    polygon {
      stroke-width: 7px;
      animation: fake-neon-glow 2s ease-in-out infinite alternate;
    }
  }
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    list-style-type: none;
    display: inline-block;

    a {
      color: #fff;
      font-weight: 700;
    }
  }
}

@keyframes fake-neon-glow {
  from {
    stroke-width: 7px;
  }
  to {
    stroke-width: 5px;
  }
}
@keyframes glow {
  from {
    filter: blur(7px);
    opacity: 0.8;
  }
  to {
    filter: blur(14px);
    opacity: 1;
  }
}
</style>
